import { Text } from '@/components/ui/text'
import type { Tables } from '@hvf/contracts'
import { Triangle } from 'lucide-solid'
import { Show } from 'solid-js'
import { Box, Flex } from 'styled-system/jsx'

export default function (props: { setup?: Tables<'setup'>, textStyle?: string, fontSize?: string, iconSize?: number, gap?: string, maxW?: string }) {
  return (
    <Flex alignItems='center' gap={props.gap || '1'}>
      <Text
        truncate
        maxW={props.maxW || '100px'}
        overflow='hidden'
        {...(props.fontSize ? { fontSize: props.fontSize } : { textStyle: props.textStyle || 'lg' })}
        fontWeight='600'
        letterSpacing='-.01em'
        color='editorialInk'
      >
        {props.setup?.symbol}
      </Text>
      <Show
        when={props.setup?.position === 'long'}
        fallback={
          <Box transform='rotate(180deg)'>
            <Triangle
              fill='var(--colors-editorial-short)'
              stroke='var(--colors-editorial-short)'
              size={props.iconSize || 12} />
          </Box>
        }
      >
        <Triangle
          fill='var(--colors-editorial-long)'
          stroke='var(--colors-editorial-long)'
          size={props.iconSize || 12} />
      </Show>
    </Flex>
  )
}
